import React from 'react';
import { Outlet } from 'react-router-dom';
import { StoreNavHeaderV1 } from './StoreNavHeaderV1.tsx';
import { StoreFooterV1 } from './StoreFooterV1.tsx';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    shopLayout: {
        backgroundColor: '#f8f9fa',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Keep minHeight but allow growth
    },
    
    content: {
        flex: 1,
    },
});

export const StoreLayoutV1: React.FC = () => {
    const styles = useStyles();

    return (
        <div className={styles.shopLayout}>
            <StoreNavHeaderV1 />
            <div className={styles.content}>
                <Outlet />
            </div>
            <StoreFooterV1 />
        </div>
    );
};
